import { AxiosResponseHeaders } from 'axios';
import {
  CreatedFavouriteTransaction,
  CreatedFavouriteTransactionResponseDTO,
} from '../../entities/FavouriteTransaction';

const createdFavouriteTransactionsResponseDTOToCreatedFavouriteTransactionsAdapter = (
  data: CreatedFavouriteTransactionResponseDTO,
  headers?: AxiosResponseHeaders,
): CreatedFavouriteTransaction => {
  if (!data.body) {
    throw new Error();
  }

  return new CreatedFavouriteTransaction(data.body.id);
};

export { createdFavouriteTransactionsResponseDTOToCreatedFavouriteTransactionsAdapter };
